import React,{useState,useEffect,useRef} from "react";
import { getNewCondidatePreviousEmpDetailsList } from "../../../Redux/Actions/newJoinerAction";
import {addCandidatePreviousEmpDetails,updateCandidatePreviousEmpDetails} from '../../HR/onboarding/api/Calls'
import { useDispatch } from "react-redux";
import moment from 'moment';
// import { DatePicker } from 'react-responsive-datepicker'
// import '../../../CommanCom/dist/index.css'
const AddPreviousEmpModel = ({edit,userID,setSelected}) =>{
  console.log('Emp Details')
  console.log(edit)
    const dispatch = useDispatch()
    const cancelRef = useRef(null);
    const reliving_letter = useRef(null);
    const initialValues = {
      company_name: "",
      position:"",
      supervisor:'',
      from_date:'',
      to_date:'',
      address_employer:'',
      reason_leaving:''
    };
const NumericValueState = {
    supervisor_mobno:'',
    total_pre_ctc:'',
    
    }
const [values, setValues] = useState(initialValues);
const [Numeric, setNumeric] = useState(NumericValueState);
const [RelivingLetterDoc,setRelivingLetter] = useState('');
const [AppointmentLetter ,setAppointmentLetter] = useState('');
//const [isOpen, setIsOpen] = React.useState(false)

const handleChange =  (e) => {
    const { name, value } = e.target;
    console.log(value)
    setValues({ ...values, [name]: value });
}
const handleCancel = () => {
    setSelected(null);
    setValues(initialValues);
    setNumeric(NumericValueState)
    setRelivingLetter('');
    setAppointmentLetter('');
};

const handleNumericChange =(e) =>{
    const { name, value } = e.target;
    const re = /^[0-9]*[.,]?[0-9]*$/;
    if (e.target.value === '' || re.test(e.target.value)) {
      setNumeric({...Numeric,[name]:value})
    }
 }
const handleRelivingLetterChange =  (e) => {
    setRelivingLetter(e.target.files[0]);
};
const handleAppointmentLetterChange =  (e) => {
    setAppointmentLetter(e.target.files[0]);
};
useEffect(() =>{
    if(edit) setValues(edit)
    if(edit) setNumeric({supervisor_mobno:edit.supervisor_mobno,total_pre_ctc:edit.total_pre_ctc});
    if(edit) setRelivingLetter(edit.reliving_letter);
    if(edit) setAppointmentLetter(edit.appointment_letter);
   //if(edit) reliving_letter.current.value = edit.reliving_letter;


},[edit,userID])
console.log('AppointmentLetter')
console.log(edit)
    const handleSubmit = (e) =>{
        e.preventDefault();
         if(company_name ==='' || position ==='' || supervisor ==='' || from_date ==='' || 
         to_date ==='' || address_employer ==='' || reason_leaving ==='' || supervisor_mobno ==='' || 
         total_pre_ctc ==='' || RelivingLetterDoc === '' || AppointmentLetter === '')
         {
            return alert('All field is required !');
         }else{
             const formdata = new FormData();
                formdata.append('user_id',userID);
                formdata.append('company_name', company_name);
                formdata.append('position', position);
                formdata.append('supervisor', supervisor);
                formdata.append('from_date', from_date);
                formdata.append('to_date', to_date);
                formdata.append('address_employer', address_employer);
                formdata.append('reason_leaving', reason_leaving);
                formdata.append('supervisor_mobno', supervisor_mobno);
                formdata.append('total_pre_ctc', total_pre_ctc);
                formdata.append('reliving_letter', RelivingLetterDoc);
                formdata.append('appointment_letter', AppointmentLetter);
                formdata.append('created_by', userID);
                formdata.append('created_on',new Date('YYYY-mm-dd'))
        //    console.log(formdata)
             addCandidatePreviousEmpDetails(formdata).then((res) =>{
                if (res.status) {
                    setValues(initialValues)
                    cancelRef.current.click();
                    dispatch(getNewCondidatePreviousEmpDetailsList(userID));
                    return alert(res.msg)
                }else{
                    return alert(res.msg)
                }
            })
         }
    }
    // const selectDateHandler =(e)=>{
    //     e.preventDefault();
    //     setIsOpen(false);
    // }
    const handleUpdateInfo = (e) =>{
        e.preventDefault();
        if(company_name ==='' || position ==='' || supervisor ==='' || from_date ==='' || 
        to_date ==='' || address_employer ==='' || reason_leaving ==='' || supervisor_mobno ==='' || 
        total_pre_ctc ==='' || RelivingLetterDoc === '' || AppointmentLetter === '')
        {
           return alert('All field is required !');
        }else{
            const formdata = new FormData();
               formdata.append('company_name', company_name);
               formdata.append('position', position);
               formdata.append('supervisor', supervisor);
               formdata.append('from_date', from_date);
               formdata.append('to_date', to_date);
               formdata.append('address_employer', address_employer);
               formdata.append('reason_leaving', reason_leaving);
               formdata.append('supervisor_mobno', supervisor_mobno);
               formdata.append('total_pre_ctc', total_pre_ctc);
               formdata.append('reliving_letter', RelivingLetterDoc);
               formdata.append('appointment_letter', AppointmentLetter);
               formdata.append('updated_by', userID);
       //    console.log(formdata)
            updateCandidatePreviousEmpDetails(formdata,edit.id).then((res) =>{
               if (res.status) {
                   setValues(initialValues)
                   cancelRef.current.click();
                   dispatch(getNewCondidatePreviousEmpDetailsList(userID));
                   return alert(res.msg)
               }else{
                   return alert(res.msg)
               }
           })
        }
    }
    const changeAppointmentUploadHandler = (e) =>{
      e.preventDefault();
      setAppointmentLetter('');
      console.log(AppointmentLetter)
    }
    const changeRelivingLetterDocHandler = (e) =>{
      e.preventDefault();
      setRelivingLetter('');
      reliving_letter.current.value = null;
    }
    const {company_name,position,supervisor,from_date,to_date,address_employer,reason_leaving} = values
    const {supervisor_mobno,total_pre_ctc} = Numeric;
    return(
        <>
        <div className="modal fade" id="previouscompanydetail" tabIndex={-1} aria-labelledby="previousModalLabel" aria-hidden="true">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-body">
                <button type="button" className="float-end btn_close" ref={cancelRef} onClick={handleCancel} data-bs-dismiss="modal" aria-label="Close">
                  <i className="icon icon-cross" />
                </button>
                <div className="dash_white_box_ttl text-center mb10" id="previousModalLabel">{edit === null ?'Add':'Update'} Previous Employment Detail</div>
                <form>
                  <div className="row mb10">
                    <div className="col-md-6">
                      <div className="form-blk mb15">
                        <div className="col-form-label">Company Name <sup className="error_mgs">*</sup></div>
                        <div className="form-input">
                          <input type="text" name="company_name" value={company_name} onChange={handleChange} id="company_name" className="form-control form-control1" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-blk mb15">
                        <div className="col-form-label">Title of Position <sup className="error_mgs">*</sup></div>
                        <div className="form-input">
                          <input type="text" name="position" value={position} onChange={handleChange} id="position" className="form-control form-control1" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-blk mb15">
                        <div className="col-form-label">Name of Supervisor <sup className="error_mgs">*</sup></div>
                        <div className="form-input">
                          <input type="text" name="supervisor" value={supervisor} onChange={handleChange} id="supervisor" className="form-control form-control1" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-blk mb15">
                        <div className="col-form-label">Phone Number of Supervisor <sup className="error_mgs">*</sup></div>
                        <div className="form-input">
                          <input type="text" name="supervisor_mobno" value={supervisor_mobno} onChange={handleNumericChange} id="supervisor_mobno" className="form-control form-control1" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-blk mb15">
                        <div className="col-form-label">From Date <sup className="error_mgs">*</sup></div>
                        <div className="form-input">
                          <input type="date" name="from_date" value={moment(from_date).format('yyyy-MM-DD')} onChange={handleChange} id="from_date" className="form-control form-control1" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-blk mb15">
                        <div className="col-form-label">To Date <sup className="error_mgs">*</sup></div>
                        <div className="form-input">
                       
                        {/* <DatePicker
                            isOpen={true}
                            onClose={(e) => selectDateHandler}
                            defaultValue={new Date(2022, 8, 8)}
                            minDate={new Date(2022, 10, 10)}
                            maxDate={new Date(2023, 0, 10)}
                            headerFormat='DD, MM dd'
                        /> */}
                          <input type="date" name="to_date" value={moment(to_date).format('yyyy-MM-DD')} id="to_date" onChange={handleChange} className="form-control form-control1" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-blk mb15">
                        <div className="col-form-label">Total CTC including Benefits <sup className="error_mgs">*</sup></div>
                        <div className="form-input">
                          <input type="text" name="total_pre_ctc" value={total_pre_ctc} onChange={handleNumericChange} id="total_pre_ctc" className="form-control form-control1" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-blk mb15">
                        <div className="col-form-label">Address of Employer <sup className="error_mgs">*</sup></div>
                        <div className="form-input">
                          <input type="text" name="address_employer" value={address_employer}  onChange={handleChange} id="address_employer" className="form-control form-control1" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-blk mb15">
                        <div className="col-form-label">Reason for Leaving </div>
                        <div className="form-input">
                          <input type="text" name="reason_leaving" value={reason_leaving} onChange={handleChange}  id="reason_leaving" className="form-control form-control1" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-blk mb15">
                        <div className="col-form-label">Upload Reliving Letter <sup className="error_mgs">*</sup></div>
                        <div className="form-input input-group">
                          {RelivingLetterDoc !=''?
                          <input type="file" name="reliving_letter" ref={reliving_letter} onChange={handleRelivingLetterChange} className="form-control uploadbtn" id="reliving_letter" />
                          :
                          <input type="file" name="reliving_letter" ref={reliving_letter} onChange={handleRelivingLetterChange} className="form-control uploadbtn" id="reliving_letter" />
                          }
                          {RelivingLetterDoc != ''?<button className="btn_2 btn-2" onClick={changeRelivingLetterDocHandler}><i class="icon icon-cross"></i></button>:''}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-blk mb15">
                        <div className="col-form-label">Upload Appointment Letter <sup className="error_mgs">*</sup></div>
                        <div className="form-input input-group">
                          {AppointmentLetter !='' ?
                          <input type="file" name="appointment_letter"  onChange={handleAppointmentLetterChange} className="form-control uploadbtn" id="appointment_letter"  />
                          :
                          <input type="file" name="appointment_letter"  onChange={handleAppointmentLetterChange} className="form-control uploadbtn" id="appointment_letter" />}
                          
                          {AppointmentLetter != ''?<button className="btn_2 btn-2" onClick={changeAppointmentUploadHandler}><i class="icon icon-cross"></i></button>:''}
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
                <div className="modalfooter">
                  <button type="button" className="btn_6 float-end ml10" ref={cancelRef} onClick={handleCancel} data-bs-dismiss="modal">Cancel</button>
                  <button type="button" className="btn_5 float-end " onClick={edit === null ? handleSubmit:handleUpdateInfo} >{edit === null ?'Add':'Update'}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        </>
    )
}
export default AddPreviousEmpModel;